export const MetaDataObjects = {
  Organisation: 1,
  Person: 2,
  Activity: 4,
  Product: 5,
  Order: 6,
  Quotation: 13,
  WebAccount: 15,
  Subscription: 19,
  OrderLine: 27,
  QuoteLine: 28,
  EventDelegate: 29,
  EventBooking: 30,
  EventSession: 31,
  ProdUsageData: 36,
  SubscriptionHeader: 41,
  Event2Instance: 56,
  ProductPrice: 60,
  Event2Session: 62,
  Event2Booking: 63,
  Event2Delegate: 64,
} as const;
